import Event from './event';
import EventOptions from './event-options';
import Nomination from './nomination';
import Stage from './stage';

export default class AdminEventTemplateData {
  constructor(data) {
    this.address = data.address || null;
    this.event = new Event({ ...(data.event || {}), options: (data.options || {}) }, '');
    this.groups = data.groups || [];
    this.nominations = (data.nominations || []).map((nomination) => new Nomination(nomination, ''));
    this.options = new EventOptions(data.options || {}, '');
    this.quota = data.quota || null;
    this.stages = (data.stages || []).map((stage) => new Stage(stage, ''));
    this.step = data.step || null;
    this.templates = data.templates || [];
    this.template_configs = data.template_configs || [];
    this.user_event_info_requests = data.user_event_info_requests || [];
  }
}
